import apiClient from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

const handleRequest = async (endpoint, params, signal) => {
  try {
    const query = buildQuery(params);
    const url = `${endpoint}${query ? `?${query}` : ''}`;
    const response = await apiClient.get(url, { signal });
    return {
      success: response.responseCode === 200,
      data: response.data || null,
      error: null
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error.response?.data?.responseMessage || 'Failed to fetch analytics'
    };
  }
};

const productAnalyticsService = {
  // Legacy call for all (keeps backward compatibility)
  getProductSalesAnalytics: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.BASE, params, signal);
  },

  getSummary: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.SUMMARY, params, signal);
  },

  getTrend: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.TREND, params, signal);
  },

  getTopItems: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.TOP_ITEMS, params, signal);
  },

  getStateBreakdown: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.STATE_BREAKDOWN, params, signal);
  },

  getTable: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.TABLE, params, signal);
  },

  getTopCustomersLeaderboard: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.TOP_CUSTOMERS, params, signal);
  },

  getMonthComparison: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.MONTH_COMPARISON, params, signal);
  },

  getSixMonthTrend: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.SIX_MONTH_TREND, params, signal);
  },

  getSixMonthTopProducts: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.SIX_MONTH_TOP_PRODUCTS, params, signal);
  },

  getReconciliation: async (params = {}, signal = null) => {
    return handleRequest(API_ENDPOINTS.CRM.PRODUCT_ANALYTICS.RECONCILIATION, params, signal);
  }
};

export default productAnalyticsService;
